export const createGetPostcastSessionsRequest = (page = 1, per_page = 10) => {
  return {
    url: "/postcast_sessions",
    method: "GET",
    params: {
      page,
      per_page,
    },
  };
};

export const createGetPostcastSessionsRequestV2 = (page = 1, per_page = 10) => {
  return {
    url: "/postcast_sessions/v2",
    method: "GET",
    params: {
      page,
      per_page,
    },
  };
};

export const createGetPostcastSessionRequest = (id) => {
  return {
    url: "/postcast_sessions/" + id,
    method: "GET",
  };
};

export const createGetSuggestedTopicsRequest = () => {
  return {
    url: "/postcast_sessions/suggested_topics",
    method: "GET",
  };
};

export const createGetCompletedPostcastSessionsRequest = () => {
  return {
    url: "/postcast_sessions/completed",
    method: "GET",
  };
};

export const createCreatePostcastSessionRequest = (sessionData) => {
  return {
    url: "/postcast_sessions",
    method: "POST",
    data: sessionData,
  };
};

export const createUpdatePostcastSessionRequest = (id, sessionData) => {
  return {
    url: "/postcast_sessions/" + id,
    method: "PUT",
    data: sessionData,
  };
};

export const createDeletePostcastSessionRequest = (id) => {
  return {
    url: "/postcast_sessions/" + id,
    method: "DELETE",
  };
};

export const createStartPostcastSessionRequest = (sessionId, agentPersonality = "alex") => {
  return {
    url: "/postcast_sessions/" + sessionId + "/start",
    method: "POST",
    data: {
      agent_personality: agentPersonality,
    },
  };
};

// Asks the backend whether the interviewee's last answer had enough in it to
// move on, or whether the agent should push once more first. v2 interviews
// only. Called once per interviewee turn, so it must stay cheap and must never
// block the conversation — callers treat any failure as "move on".
export const createPostcastAnswerCoverageRequest = (sessionId, body) => {
  return {
    url: "/postcast_sessions/" + sessionId + "/answer_coverage",
    method: "POST",
    data: body,
  };
};

export const createCompletePostcastSessionRequest = (sessionId, transcriptText, durationSeconds) => {
  return {
    url: "/postcast_sessions/" + sessionId + "/complete",
    method: "POST",
    data: {
      transcript_text: transcriptText,
      duration_seconds: durationSeconds,
    },
  };
};

// Mint a presigned upload URL for a postcast recording. Dedicated to
// recordings (not the shared /media mint) so the BE stamps the new
// MediaItem with media_type='recording'. Returns
// { media_id, upload: { url, fields, key } }.
export const createPostcastRecordingUploadUrlRequest = (sessionId, body) => {
  return {
    url: "/postcast_sessions/" + sessionId + "/recording/upload_url",
    method: "POST",
    data: body,
  };
};

// Attach a confirmed MediaItem to the session as the recording. Mirrors
// the public attach endpoint in shape but uses the standard authed path.
export const createAttachPostcastRecordingRequest = (sessionId, body) => {
  return {
    url: "/postcast_sessions/" + sessionId + "/recording",
    method: "POST",
    data: body,
  };
};

export const createDeletePostcastRecordingRequest = (sessionId) => {
  return {
    url: "/postcast_sessions/" + sessionId + "/recording",
    method: "DELETE",
  };
};

export const createAgenticGeneratePostFromSessionRequest = (sessionId, contentWritingStyleId, hooks = [], useContentDna = false) => {
  return {
    url: "/postcast_sessions/" + sessionId + "/generate_agentic_post",
    method: "POST",
    data: {
      content_writing_style_id: contentWritingStyleId,
      hooks: hooks,
      use_content_dna: useContentDna,
    },
  };
};

export const createGeneratePostFromSessionRequest = (sessionId, contentWritingStyleId, hooks = [], useContentDna = false) => {
  return {
    url: "/postcast_sessions/" + sessionId + "/generate_post",
    method: "POST",
    data: {
      content_writing_style_id: contentWritingStyleId,
      hooks: hooks,
      use_content_dna: useContentDna,
    },
  };
};

export const createRegenerateHooksRequest = (sessionId) => {
  return {
    url: "/postcast_sessions/" + sessionId + "/regenerate_hooks",
    method: "POST",
  };
};

export const createGetPostGenerationHistoryRequest = (sessionId) => {
  return {
    url: "/postcast_sessions/" + sessionId + "/post_generation_history",
    method: "GET",
  };
};

export const createGenerateSimilarPostsRequest = (sessionId, originalPostContent, contentWritingStyleId = "", numberOfVariations = 3, variationInstructions = "") => {
  return {
    url: "/postcast_sessions/" + sessionId + "/generate_similar_posts",
    method: "POST",
    data: {
      original_post_content: originalPostContent,
      content_writing_style_id: contentWritingStyleId,
      number_of_variations: numberOfVariations,
      variation_instructions: variationInstructions,
    },
  };
};

export const createGetPublicPostcastSessionRequest = (publicUrlId) => ({
  url: `/public/post_cast_sessions/${publicUrlId}`,
  method: "GET",
});

export const createStartPublicPostcastSessionRequest = (publicUrlId) => ({
  url: `/public/post_cast_sessions/${publicUrlId}/start`,
  method: "POST",
});

// Guest counterpart of createPostcastAnswerCoverageRequest. Keyed by the magic
// link id rather than the session id, matching every other public route.
export const createPublicPostcastAnswerCoverageRequest = (publicUrlId, body) => ({
  url: `/public/post_cast_sessions/${publicUrlId}/answer_coverage`,
  method: "POST",
  data: body,
});

export const createCompletePublicPostcastSessionRequest = (publicUrlId, data) => ({
  url: `/public/post_cast_sessions/${publicUrlId}/complete`,
  method: "POST",
  data,
});

